/** Sentinel ID used when Compose Canvas loads a builder action without a real entity. */
export const STUDIO_PREVIEW_SENTINEL_ID = '__studio_preview__';

/** True when the id is a real entity GUID the studio should fetch for (not empty / sentinel). */
export function isStudioPreviewEntityId(id?: string): id is string {
  return Boolean(id && id !== STUDIO_PREVIEW_SENTINEL_ID);
}

/**
 * Resolve the entity id passed to FormRenderer / fetch actions.
 * In studio preview, the Compose Canvas input wins over a stale block.entityId from a prior dry-run load.
 */
export function resolveStudioBlockEntityId(
  params: Record<string, string> | undefined,
  blockEntityId: string | undefined,
  isStudioPreview: boolean,
): string | undefined {
  const canvasId = isStudioPreviewEntityId(params?.id) ? params!.id : undefined;
  const blockId = isStudioPreviewEntityId(blockEntityId) ? blockEntityId : undefined;
  if (isStudioPreview && canvasId) return canvasId;
  return blockId ?? canvasId;
}
